import type { Country } from '@/domain/Country';
import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface CountriesResponse {
  data: Array<Country>;
}

export const countriesQuery = queryOptions({
  queryKey: queryKeys.countries.all(),
  queryFn: async () => api.get('countries').json<CountriesResponse>(),
  staleTime: 1000 * 60 * 60,
});
